import { render, staticRenderFns } from "./ZendeskText.vue?vue&type=template&id=5f58400b&"
import script from "./ZendeskText.vue?vue&type=script&lang=js&"
export * from "./ZendeskText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports